import { amplitudeProvider } from 'Utils/analytics/amplitudeProvider';
import { gaProvider } from 'Utils/analytics/gaProvider';
import { mixpanelProvider } from 'Utils/analytics/mixpanelProvider';
import { getPageNameFromUrl } from 'Utils/analytics/pageRoutes';

// queue for events fired before init() is called
let eventQueue = [];
let isInitialized = false;

const providers = [amplitudeProvider, gaProvider, mixpanelProvider];

const flushQueue = () => {
  eventQueue.forEach(({ name, data }) => {
    providers.forEach(p => p.track(name, data));
  });
  eventQueue = [];
};

export const analyticsService = {
  init() {
    const {
      AMPLITUDE_API_KEY,
      GOOGLE_API_KEY,
      MIXPANEL_API_KEY,
    } = process.env;

    amplitudeProvider.init(AMPLITUDE_API_KEY);
    gaProvider.init(GOOGLE_API_KEY);
    mixpanelProvider.init(MIXPANEL_API_KEY);

    isInitialized = true;
    flushQueue();
  },

  track(name, data = {}) {
    const enrichedData = {
      ...data,
      page: getPageNameFromUrl(window.location.pathname),
    };

    if (!isInitialized) {
      // buffer events fired before init (e.g. from module-level code)
      eventQueue.push({ name, data: enrichedData });
      return;
    }

    providers.forEach(p => p.track(name, enrichedData));
  },

  identify(id, traits = {}) {
    if (!isInitialized) return;
    providers.forEach(p => p.identify(id, traits));
  },
};
